import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import PropTypes from "prop-types";

// @material-ui core components
import NotificationsIcon from "@mui/icons-material/Notifications";
import AppBar from "@mui/material/AppBar";
import Badge from "@mui/material/Badge";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";

// Material Dashboard 2 PRO React components
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarIconButton,
  navbarMobileMenu,
  navbarRow
} from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 PRO React context
import {
  setDarkMode,
  setMiniSidenav,
  setTransparentNavbar,
  useMaterialUIController
} from "context";
import { useUser } from "context/UserContext";
import { logoutSystem, postNoResponse, get, post } from "utils/WebService";
import MDButton from "components/MDButton";

function DashboardNavbar({
  absolute = false,
  light = false,
  isMini = false }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, darkMode } = controller;
  const [openMenu, setOpenMenu] = useState(false);

  const [anchorNotif, setAnchorNotif] = useState(null);
  const [hasUnread, setHasUnread] = useState(true);
  
  const handleOpenNotif = (event) => {
    setAnchorNotif(event.currentTarget);
  };
  const handleCloseNotif = () => setAnchorNotif(null);

  const { userId } = useUser();

  const navigate = useNavigate();

  useEffect(() => {

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const [notifResume, setNotifResume] = useState(null);

  useEffect(() => {
    // Busca o contador de notificacoes do Backend
    get("/notifications/resume")
      .then((res) => {
        setNotifResume(res);
        const totalAlerts = (res?.totalSolicitacoes || 0) + (res?.totalEventosHoje || 0) + (res?.totalFichasHoje || 0) + (res?.totalFichasAtrasadas || 0);
        setHasUnread(totalAlerts > 0);
      })
      .catch((err) => console.log("Erro ao buscar notificações", err));
  }, []);



  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleDarkMode = () => {
    const nextMode = !darkMode;
    sessionStorage.setItem('tema', nextMode);
    setDarkMode(dispatch, nextMode);
  };
  const handleCloseMenu = () => setOpenMenu(false);

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }} >
    </Menu>
  );


  const renderNotifMenu = (
    <Menu
      anchorEl={anchorNotif}
      open={Boolean(anchorNotif)}
      onClose={handleCloseNotif}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ mt: 1 }}
    >
      <MenuItem onClick={handleCloseNotif} sx={{ p: 1.5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <MDBox display="flex" alignItems="center" mb={0.5}>
          <Icon fontSize="inherit" sx={{ mr: 1, color: notifResume?.totalSolicitacoesUrgentes > 0 ? 'error.main' : 'warning.main', fontSize: '14px' }}>
            assignment
          </Icon>
          <MDTypography variant="button" fontWeight="bold" sx={{ fontSize: '10px' }}>
            Solicitações Pendentes
          </MDTypography>
        </MDBox>
        <MDTypography variant="caption" color="text" sx={{ fontSize: '10px', pl: 2.5 }}>
           Você possui {notifResume?.totalSolicitacoes || 0} solicitações atribuídas.{' '}
           {notifResume?.totalSolicitacoesUrgentes > 0 && (
             <strong style={{ color: '#F44335' }}>({notifResume?.totalSolicitacoesUrgentes} URGENTE)</strong>
           )}
        </MDTypography>
      </MenuItem>

      {(notifResume?.hasProcessos !== false) && (
        <MenuItem onClick={() => { handleCloseNotif(); navigate('/agenda'); }} sx={{ p: 1.5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <MDBox display="flex" alignItems="center" mb={0.5}>
          <Icon fontSize="inherit" sx={{ mr: 1, color: notifResume?.totalEventosHoje > 0 ? 'warning.main' : 'info.main', fontSize: '14px' }}>
            event
          </Icon>
          <MDTypography variant="button" fontWeight="bold" sx={{ fontSize: '10px' }}>
            Compromissos / Eventos
          </MDTypography>
        </MDBox>
        <MDTypography variant="caption" color="text" sx={{ fontSize: '10px', pl: 2.5 }}>
           Total de {notifResume?.totalEventos || 0} eventos na pauta.{' '}
           {notifResume?.totalEventosHoje > 0 && (
             <strong style={{ color: '#FB8C00' }}>({notifResume?.totalEventosHoje} DO DIA)</strong>
           )}
        </MDTypography>
        </MenuItem>
      )}

      {(notifResume?.hasCobranca !== false) && (
        <MenuItem onClick={() => { handleCloseNotif(); navigate('/agenda'); }} sx={{ p: 1.5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <MDBox display="flex" alignItems="center" mb={0.5}>
          <Icon fontSize="inherit" sx={{ mr: 1, color: notifResume?.totalFichasAtrasadas > 0 ? 'error.main' : (notifResume?.totalFichasHoje > 0 ? 'warning.main' : 'info.main'), fontSize: '14px' }}>
            contact_phone
          </Icon>
          <MDTypography variant="button" fontWeight="bold" sx={{ fontSize: '10px' }}>
            Fichas Agendadas
          </MDTypography>
        </MDBox>
        <MDTypography variant="caption" color="text" sx={{ fontSize: '10px', pl: 2.5 }}>
           Você possui {notifResume?.totalFichasHoje || 0} fichas para hoje.{' '}
           {notifResume?.totalFichasAtrasadas > 0 && (
             <strong style={{ color: '#F44335' }}>({notifResume?.totalFichasAtrasadas} ATRASADAS)</strong>
           )}
        </MDTypography>
        </MenuItem>
      )}
    </Menu>
  );

  // Styles for the navbar icons
  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });

  const handleSumit = () => {
    handleDarkMode()

    const body = {
      id: userId,
      temaDark: !darkMode
    }
    sessionStorage.setItem('tema', !darkMode);

    postNoResponse("/users/save-theme", body)
      .then(() => {
      })
  }

  function logout() {
    logoutSystem();
  }

  return (
    <AppBar
      position={absolute ? "absolute" : "static"}
      color="inherit"
      sx={(theme) => ({
        ...navbar(theme, { transparentNavbar, absolute, light, darkMode }),
        minHeight: 'auto',
      })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
        </MDBox>
        {isMini ? null : (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            <MDBox color={light ? "white" : "inherit"} display="flex" alignItems="center">
              
              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                <Icon sx={iconsStyle} fontSize="medium">
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>

              <IconButton
                size="small"
                disableRipple
                color="inherit"
                onClick={handleSumit}
                sx={{ mr: 1 }}
              >
                <Icon sx={iconsStyle}>{darkMode ? "light_mode" : "dark_mode"}</Icon>
              </IconButton>

              <IconButton
                size="small"
                disableRipple
                color="inherit"
                onClick={handleOpenNotif}
                sx={{
                  mr: 1,
                  "& .MuiBadge-badge": {
                    height: 11,
                    width: 11,
                    borderRadius: "50%",
                    border: "2px solid #fff",
                    boxShadow: "0px 0px 4px rgba(0,0,0,0.3)",
                    animation: hasUnread ? "pulse 2s infinite" : "none",
                  },
                  "@keyframes pulse": {
                    "0%": {
                      boxShadow: "0 0 0 0 rgba(244, 67, 54, 0.7)",
                    },
                    "70%": {
                      boxShadow: "0 0 0 8px rgba(244, 67, 54, 0)",
                    },
                    "100%": {
                      boxShadow: "0 0 0 0 rgba(244, 67, 54, 0)",
                    },
                  },
                  "&:hover svg": {
                    animation: "ring 1.5s ease-in-out",
                  },
                  "@keyframes ring": {
                    "0%": { transform: "rotate(0deg)" },
                    "15%": { transform: "rotate(15deg)" },
                    "30%": { transform: "rotate(-10deg)" },
                    "45%": { transform: "rotate(5deg)" },
                    "60%": { transform: "rotate(-5deg)" },
                    "75%": { transform: "rotate(0deg)" },
                    "100%": { transform: "rotate(0deg)" }
                  }
                }}
              >
                <Badge variant="dot" color="error" invisible={!hasUnread}>
                  <NotificationsIcon sx={iconsStyle} />
                </Badge>
              </IconButton>
              {renderNotifMenu}

              {renderMenu()}
              <IconButton
                size="small"
                disableRipple
                color="inherit"
                onClick={logout}
              >
                <Icon sx={iconsStyle}>logout</Icon>
              </IconButton>
            </MDBox>
          </MDBox>
        )}
      </Toolbar>
    </AppBar>
  );
}



// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
